import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { createElement } from "react";
import i18next from "i18next";
import { useTranslationApp } from "../../lib/i18next";
import {
  ALERT_POPUP_BLOCKED_DESCRIPTION,
  ALERT_POPUP_BLOCKED_TITLE,
  OK,
} from "../../i18n/keysTranslations";
import popupBlockedGuideGif from "../../assets/img/pop_up.gif";
import { firePlainHtmlBuzzlyAlert } from "./Alerts";

const PopupBlockedGuideAlertContent = () => {
  const { t } = useTranslationApp();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 2,
        width: "100%",
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontWeight: 600,
          textAlign: "center",
        }}
      >
        {t(ALERT_POPUP_BLOCKED_TITLE)}
      </Typography>

      <Typography
        variant="body2"
        sx={{
          textAlign: "center",
        }}
      >
        {t(ALERT_POPUP_BLOCKED_DESCRIPTION)}
      </Typography>

      <Box
        component="img"
        alt={t(ALERT_POPUP_BLOCKED_DESCRIPTION)}
        src={popupBlockedGuideGif}
        sx={{
          width: "100%",
          objectFit: "cover",
          borderRadius: 2,
        }}
      />
    </Box>
  );
};

export const PopupBlockedGuideAlert = ({
  confirmButtonText = i18next.t(OK),
} = {}) =>
  firePlainHtmlBuzzlyAlert({
    confirmButtonText,
    html: createElement(PopupBlockedGuideAlertContent),
    width: "min(680px, 92vw)",
  });
